import { PAGE_ONE } from "ui/pagination";
import { IPaginationParams } from "ui/pagination/types";

export const columns = [
  "Date and Time",
  "Type",
  "Description",
  "Source Account",
  "Amount",
  "Current Balance",
  "Status",
];

export const DEFAULT_BUSINESS_TRANSACTIONS_PAGE_LIMIT = 10;
export const DEFAULT_BUSINESS_TRANSACTIONS_PAGINATION_PARAMS: IPaginationParams =
  {
    page: PAGE_ONE,
    limit: DEFAULT_BUSINESS_TRANSACTIONS_PAGE_LIMIT,
  };
